module.exports = __webpack_public_path__ + "img/fale-conosco.206add5c.webp";